/** @format — Shared search field with focus ring (chats + shipments) */

import SearchField, { SEARCH_CONTROL_H } from "@/components/filters/SearchField";

export { SEARCH_CONTROL_H };
export default SearchField;
